// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__kGCtY","alert":"SettungsInbox_alert__3wavB"};